export const DEFAULT_SEARCH_PAGE_SIZE = 50;
export const DEFAULT_SEARCH_DEBOUNCE_MS = 250;
